import classNames from 'classnames'
import { ApplicationItemStatus } from 'hooks/useAffiliateAplication'
import React from 'react'
import { ApplicationItemType } from '..'

import style from './style.module.css'

export type ApplicationItemProps = {
  header: string
  description: string
  type: ApplicationItemType
  status: ApplicationItemStatus
  actionText?: string
  actionUrl?: string
}

export default function ApplicationItemCard(props: ApplicationItemProps) {
  const { header, description, status, actionText, actionUrl } = props

  return (
    <div className={style.wrapper}>
      <svg
        className={classNames(
          style.icon,
          {
            [style.complete]: status === ApplicationItemStatus.DONE,
          },
          {
            [style.pending]: status === ApplicationItemStatus.SUBMITTED,
          },
          {
            [style.warning]: status === ApplicationItemStatus.WAITING,
          },
          { [style.defaultIcon]: status === ApplicationItemStatus.DEFAULT },
        )}
      />
      <div className={style.textContainer}>
        <h1 className={style.header}>{header}</h1>
        <h3 className={style.description}>{description}</h3>
        {actionText && actionUrl && <a href={actionUrl}>{actionText}</a>}
      </div>
    </div>
  )
}
